/* eslint-disable */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from 'material-ui/Table';
import green from 'material-ui/colors/green';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button';
import AddIcon from 'material-ui-icons/Add';

import unverifiedMailIcon from '../assets/images/icons/mail-error.png';
import boltMapIcon2 from '../assets/images/icon-map-bolt-cotton.png';

import { withRouter } from 'react-router';
import { lighten } from 'material-ui/styles/colorManipulator';
import { translate } from 'react-i18next';

import { capitalize } from '../utils/text';

import {
  getUsersStart,
  sortUsers,
  changePage,
  changeRowsPerPage,
} from '../actions';

import { enums } from '../enums';
import { checkUserIsAdmin } from '../utils/user/checkAdmin/CheckAdmin';
/**
 * Common component import
 */
import LoadingCircle from '../components/commons/LoadingCircle';
let counter = 0;

function createData(name, id, fat, carbs, protein) {
  counter += 1;
  return { id: counter, name, id, fat, carbs, protein };
}

const columnData = [
  { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
  {
    id: 'organization',
    numeric: false,
    disablePadding: false,
    label: 'Organization',
  },
];

class UsersHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, t } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t('Sort')}
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

UsersHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let UsersToolbar = props => {
  const { numSelected, classes, loading, t, i18n } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            {t('Users')}
            {loading && (
              <LoadingCircle type="buttonProgress" classes={classes} />
            )}
          </Typography>
        )}
      </div>
    </Toolbar>
  );
};

UsersToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

UsersToolbar = withStyles(toolbarStyles)(UsersToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    bottom: -30,
    left: 100,
    marginTop: -12,
    marginLeft: -12,
  },
});

class Users extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: 'asc',
      orderBy: 'id',
      selected: [],
      data: [
        createData('Frasnes', 0, 3.7, 67, 4.3),
        createData('Fontanelles', 1, 25.0, 51, 4.9),
        createData('Eget', 2, 16.0, 24, 6.0),
        createData('Burgum', 3, 6.0, 24, 4.0),
        createData('Marèges', 4, 16.0, 49, 3.9),
      ].sort((a, b) => (a.id < b.id ? -1 : 1)),
      page: 0,
      rowsPerPage: 5,
    };
  }
  componentDidMount = () => {
    if (this.props.isAuthenticated) {
      this.props.getUsersStart();
    } else {
      this.props.history.push('/');
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.props.orderBy === property && this.props.order === 'desc') {
      order = 'asc';
    }

    this.props.sortUsers(assets, order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  handleClick = (event, user_id) => {
    this.props.history.push('/users/read/' + user_id);
  };

  //Below are functions provided initially by material ui
  //Visit https://material-ui-next.com/demos/tables/#sorting-amp-selecting for details

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.state.data.map(n => n.id) }); //Do this redux way
      return;
    }
    this.setState({ selected: [] }); //Do this redux way
  };

  handleClickSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPage(event.target.value);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  renderCreateButton() {
    const { classes, user, isAuthenticated } = this.props;
    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.button}
          style={{
            margin: 0,
            bottom: 'auto',
            right: 48,
            top: 85,
            left: 'auto',
            position: 'fixed',
          }}
          onClick={() => {
            this.props.history.push('/users/create');
          }}
        >
          <AddIcon />
        </Button>
      );
    }
  }

  render() {
    const { classes } = this.props;

    const {
      users,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      loading,
      t,
      i18n,
    } = this.props;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, users.length - page * rowsPerPage);

    return (
      <div className={classes.root}>
        <Paper className={classes.root}>
          <UsersToolbar
            numSelected={selected.length}
            loading={loading}
            t={t}
            i18n={i18n}
          />
          <div>
            <Table
              className={classes.table}
              style={{ minWidth: 0, cursor: 'pointer' }}
            >
              <UsersHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={users.length}
                t={t}
                i18n={i18n}
              />
              <TableBody>
                {users
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(user => {
                    const n = user;
                    const isSelected = this.isSelected(n.id);
                    let userData = n.user_metadata ? n.user_metadata : null;
                    let userOrganization = userData.organization
                      ? userData.organization
                      : null;

                    const userRoles = user.app_metadata.roles;
                    let currentUserFullName =
                      userData && userData.firstname
                        ? capitalize(userData.firstname)
                        : '';
                    currentUserFullName +=
                      userData && userData.lastname
                        ? ' ' + capitalize(userData.lastname)
                        : '';

                    return (
                      <TableRow
                        hover
                        onClick={event =>
                          this.handleClick(event, n.identities[0].user_id)
                        }
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n.id}
                        selected={isSelected}
                      >
                        <TableCell>
                          {!n.email_verified && (
                            <img
                              src={unverifiedMailIcon}
                              style={{ maxHeight: 20, marginRight: 10 }}
                              alt="email not verified"
                              title="email not verified"
                            />
                          )}

                          {!currentUserFullName && 'Unknown user'}

                          {currentUserFullName &&
                            userData.organization &&
                            userRoles.indexOf(enums.UserRole.CUSTOMER) > -1 &&
                            currentUserFullName}

                          {currentUserFullName &&
                            userData.organization &&
                            userRoles.indexOf(enums.UserRole.ADMIN) > -1 && (
                              <div>
                                {currentUserFullName}
                                <img
                                  src={boltMapIcon2}
                                  style={{ height: 16, marginLeft: 5 }}
                                />
                              </div>
                            )}

                          {currentUserFullName &&
                            userData.organization &&
                            userRoles.indexOf(enums.UserRole.SUPER_ADMIN) >
                              -1 && (
                              <div>
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    color: '#F87733',
                                  }}
                                >
                                  {currentUserFullName}
                                </span>
                              </div>
                            )}
                        </TableCell>
                        <TableCell
                          style={{
                            cursor: 'pointer',
                          }}
                        >
                          {(!userOrganization || !userOrganization.name) && (
                            <span style={{ color: 'red', fontWeight: 'bold' }}>
                              {t('No organization')}
                            </span>
                          )}
                          {userOrganization &&
                            userOrganization.type ===
                              enums.OrganizationTypes.CUSTOMER &&
                            userOrganization.name}
                          {userOrganization &&
                            userOrganization.type ===
                              enums.OrganizationTypes.UTILITY &&
                            userOrganization.name}
                          {userOrganization &&
                            userOrganization.type ===
                              enums.OrganizationTypes.TEO && (
                              <span
                                style={{ fontWeight: 'bold', color: '#F87733' }}
                              >
                                {userOrganization.name}
                              </span>
                            )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={users.length}
            labelDisplayedRows={({ from, to, count }) =>
              from + '-' + to + t(' of ') + count
            }
            labelRowsPerPage={t('RowsPerPage')}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        {this.renderCreateButton()}
      </div>
    );
  }
}

Users.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ usersReducer, router, loginReducer }) => {
  const {
    currentUser,
    users,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
  } = usersReducer;
  const { location } = router;
  const { isAuthenticated, user, username } = loginReducer;
  return {
    currentUser,
    users,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    location,
    isAuthenticated,
    username,
    user,
  };
};

const mapDispatchToProps = {
  getUsersStart,
  sortUsers,
  changePage,
  changeRowsPerPage,
};

Users = withStyles(styles, { name: 'Users' })(Users);
Users = translate('translations')(Users);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Users)
);



// WEBPACK FOOTER //
// ./src/components/Users.js